import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Music from './pages/Music';
import Videos from './pages/Videos';
import EPK from './pages/EPK';
import Shows from './pages/Shows';
import Pix from './pages/Pix';
import Info from './pages/Info';

function App() {
  return (
    <Router>
      <Navbar />
      <div className="app-container">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/music" element={<Music />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/pix" element={<Pix />} />
        <Route path="/epk" element={<EPK />} />
        <Route path="/info" element={<Info />} />
        <Route path="/shows" element={<Shows />} />
      </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;